import axios from "axios";

export const createCampaign = async (data) => {
    const resp = await axios.post(`/reward-voucher/campaign`, data);
    return resp.data;
};

export const listCampaigns = async (companyId = 0, status = null, filter = null, page = 0, size = 10) => {
    const params = {
        page,
        size,
        ...(companyId ? { company: companyId } : {}),
        ...(status ? { status } : {}),
        ...(filter ? { filter: filter.trim() } : {}),
    };
    const resp = await axios.get(`/reward-voucher/campaign`, { params });
    return resp.data;
};

export const getCampaignDetail = async (campaignId, status = null, filter = null, page = 0, size = 10) => {
    const params = {
        page,
        size,
        ...(status ? { status } : {}),
        ...(filter ? { filter: filter.trim() } : {}),
    };
    const resp = await axios.get(`/reward-voucher/campaign/${campaignId}`, { params });
    return resp.data;
};

export const updateCampaign = async (campaignId, data) => {
    const resp = await axios.put(`/reward-voucher/campaign/${campaignId}`, data);
    return resp.data;
};

export const exportCampaigns = async (campaignIds) => {
    const resp = await axios.post(`/reward-voucher/campaign/export`, { campaignIds });
    return resp.data;
};

export const cancelCampaign = async (campaignId) => {
    const resp = await axios.delete(`/reward-voucher/campaign/${campaignId}`);
    return resp.data;
};

export const uploadCampaignImage = async (file) => {
    const form = new FormData();
    form.append("file", file);
    const resp = await axios.post(`/reward-voucher/upload-image`, form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data;
};

export const getCampaignConfig = async () => {
    const resp = await axios.get(`/reward-voucher/config`);
    return resp.data;
};

export const updateCampaignConfig = async (defaultLogoUrl) => {
    const resp = await axios.put(`/reward-voucher/config`, { defaultLogoUrl });
    return resp.data;
};

export const deleteCampaignDefaultLogo = async () => {
    const resp = await axios.delete(`/reward-voucher/config/logo`);
    return resp.data;
};

export const createBatchInCampaign = async (campaignId, name, items, idempotencyKey) => {
    const body = { name, data: items };
    const headers = { "idempotency-key": idempotencyKey };
    const resp = await axios.post(`/reward-voucher/campaign/${campaignId}/batch`, body, { headers });
    return resp.data;
};
